const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const GlossaryLetterFilter = ({ activeLetter, availableLetters, onChange, allLabel, filterLabel }) => {
  return (
    <div className="flex items-center gap-3 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
      <span className="text-grey-600 mr-1 shrink-0 text-[13px] font-semibold">{filterLabel}</span>

      <button
        type="button"
        onClick={() => onChange('all')}
        aria-pressed={activeLetter === 'all'}
        className={`flex h-[34px] shrink-0 cursor-pointer items-center justify-center rounded-[10px] border px-3 text-sm font-medium transition-colors ${
          activeLetter === 'all'
            ? 'border-brand-500 bg-brand-500 text-white'
            : 'border-grey-200 text-grey-600 hover:border-brand-500 hover:text-brand-500 bg-transparent'
        }`}
      >
        {allLabel}
      </button>

      <div className="flex shrink-0 gap-1.5">
        {ALPHABET.map((letter) => {
          const isAvailable = availableLetters.has(letter);
          const isActive = activeLetter === letter;

          return (
            <button
              key={letter}
              type="button"
              disabled={!isAvailable}
              onClick={() => isAvailable && onChange(letter)}
              aria-pressed={isActive}
              className={`flex h-[34px] w-[34px] items-center justify-center rounded-[10px] border text-sm font-medium transition-colors ${
                isActive
                  ? 'border-brand-500 bg-brand-500 cursor-pointer text-white'
                  : isAvailable
                    ? 'border-grey-200 text-grey-600 hover:border-brand-500 hover:text-brand-500 cursor-pointer bg-transparent'
                    : 'border-grey-200 text-grey-400 cursor-default bg-transparent opacity-30'
              }`}
            >
              {letter}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GlossaryLetterFilter;
